var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSizing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 18,
    viewBox: "0 0 23 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.63904 7.88072L4.66173 6.9122C4.66178 6.91218 4.66183 6.91216 4.66188 6.91213C5.42292 6.54699 6.34781 7.07933 6.34781 7.95937V16.875C6.34781 17.1536 6.58059 17.4 6.89766 17.4H16.0964C16.4135 17.4 16.6463 17.1536 16.6463 16.875V7.95586C16.6463 7.08234 17.5684 6.54216 18.3322 6.90861L18.3319 6.90845L2.63904 7.88072ZM2.63904 7.88072L0.61455 3.91578L7.16367 0.739956C8.12037 1.69462 9.74853 2.25938 11.5006 2.25938C13.2528 2.25938 14.8809 1.69462 15.8376 0.739956M2.63904 7.88072L15.8376 0.739956M20.3551 7.87721L18.3324 6.90869L22.422 3.93286L22.4211 3.93245M20.3551 7.87721L20.345 7.8969C20.3453 7.89626 20.3458 7.89559 20.3462 7.89489C20.3476 7.89295 20.3494 7.89083 20.3516 7.88899C20.3544 7.88664 20.3569 7.88544 20.3588 7.88482C20.3595 7.88459 20.3603 7.88438 20.3612 7.88424C20.3623 7.88405 20.3635 7.88395 20.3648 7.88399C20.3651 7.88399 20.3654 7.88401 20.3656 7.88402C20.3688 7.88423 20.3715 7.8851 20.3729 7.88579L20.3729 7.88575L20.3657 7.88228L20.3551 7.87721ZM20.3551 7.87721L22.3838 3.91436M22.3838 3.91436L22.4211 3.93245M22.3838 3.91436L15.8376 0.739956M22.3838 3.91436L22.4039 3.87502L22.405 3.87304C22.4046 3.87371 22.4043 3.87438 22.404 3.87505C22.3927 3.89996 22.4055 3.9243 22.4211 3.93245M22.4211 3.93245L15.8376 0.739956",
    stroke: "#807D7E",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSizing);
export default __webpack_public_path__ + "static/media/Sizing.af8d5c7568197127065edf3e3fde472a.svg";
export { ForwardRef as ReactComponent };